define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var NotificationManager = require('managers/notification.manager');
    var showLimits = require('notifications/showLimits.notification');
    var initialize = NotificationManager.prototype.initialize;

     _.extend(NotificationManager.prototype, {
        initialize: function() {
            initialize.apply(this, arguments);

            this.addCallback('showLimits', showLimits);
        }
    });

    module.exports = NotificationManager;
});
